import { render, staticRenderFns } from "./Solicitacao.vue?vue&type=template&id=0f17c4e6"
import script from "./Solicitacao.vue?vue&type=script&lang=js"
export * from "./Solicitacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports